import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SavedTemplate, RenameHistory, RenameOperation } from '../types/rename.types';

interface RenameState {
  savedTemplates: SavedTemplate[];
  lastUsedPatternId?: string;
  history: RenameHistory[];
  
  // Actions
  saveTemplate: (template: Omit<SavedTemplate, 'id' | 'createdAt'>) => void;
  deleteTemplate: (id: string) => void;
  setLastUsedPattern: (id: string) => void;
  pushHistory: (operations: RenameOperation[]) => void;
  popHistory: () => RenameHistory | undefined;
}

export const useRenameStore = create<RenameState>()(
  persist(
    (set, get) => ({
      savedTemplates: [],
      lastUsedPatternId: undefined,
      history: [],

      saveTemplate: (template) => set((state) => ({
        savedTemplates: [
          ...state.savedTemplates,
          {
            ...template,
            id: crypto.randomUUID(),
            createdAt: Date.now(),
          }
        ]
      })),

      deleteTemplate: (id) => set((state) => ({
        savedTemplates: state.savedTemplates.filter(t => t.id !== id)
      })),

      setLastUsedPattern: (id) => set({ lastUsedPatternId: id }),

      pushHistory: (operations: RenameOperation[]) => set((state) => ({
        history: [
          { id: crypto.randomUUID(), timestamp: Date.now(), operations },
          ...state.history
        ].slice(0, 10) as RenameHistory[] // Keep last 10 records
      })),

      popHistory: () => {
        const { history } = get();
        if (history.length === 0) return undefined;
        
        const lastAction = history[0];
        set({ history: history.slice(1) });
        return lastAction;
      }
    }),
    {
      name: 'webadb-rename-storage',
    }
  )
);
